"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_905 = exports.Plan_904 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_904 = exports.Plan_904 = {
  planNumber: 904,
  kindOfCover: "Accident & GVE",
  externalName: "Ultimate Cover (Accidental Injury & Illness)",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,000",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3843",
    "excessNo": 3843
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 11000,
      "formattedAmount": "$11,000",
      "displayValue": "$11,000"
    },
    "paralysisTick": "$1,200 sub-limit",
    "tickParalysis": "$1,200 sub-limit",
    "cruciateLigament": "$2,600 sub-limit",
    "consultationLimit": "$300 sub-limit",
    "consultationsAndVet": "$300 sub-limit",
    "consultationsAndVisits": "$300 sub-limit",
    "consultation": true,
    "emergencyBoardingFees": "$1,000",
    "emergencyBoardingLimit": "$1,000 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for routine care where selected.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for routine care where selected.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "routineCare": {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "groomingComplication": true,
    "coversIllness": true,
    "infectiousDisease": true,
    "ingestionOfForeignBodies": true
  },
  isBasePlan: true,
  addOns: []
};
var Plan_905 = exports.Plan_905 = _objectSpread(_objectSpread({}, Plan_904), {}, {
  planNumber: 905,
  externalName: "Ultimate Cover (Acc Injury & Illness) with RC",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3844",
    "excessNo": 3844
  }],
  limits: _objectSpread(_objectSpread({}, Plan_904.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$80",
    routineCareLimitBreakDown: [{
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 15
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 15
    }, {
      "description": "Routine Group",
      "code": "RGRSPCA",
      "limit": 50
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  isVariant: true,
  basePlanNo: 904,
  addOns: ["routineCare"],
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_904: Plan_904,
  Plan_905: Plan_905
};